import React, { lazy } from 'react';
import { ProtectedRoute } from '@components';

const SalaryDetail = lazy(() => import('./salaryDetail'));

export default {
  path: 'salaryDetail/:payrollDetailId',
  element: <ProtectedRoute title="工资条明细" component={<SalaryDetail />} />,
};
